import { render, staticRenderFns } from "./SingleInboundOrder.vue?vue&type=template&id=1685361e&scoped=true&lang=pug"
import script from "./SingleInboundOrder.vue?vue&type=script&lang=js"
export * from "./SingleInboundOrder.vue?vue&type=script&lang=js"
import style0 from "./SingleInboundOrder.vue?vue&type=style&index=0&id=1685361e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685361e",
  null
  
)

export default component.exports